import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, watch } from "vue";
    
export default /*@__PURE__*/_defineComponent({
  __name: 'commonActionButton',
  props: {
        menuItems: { type: Array, required: true },
        data: { type: Object },
        disabled: { type: Boolean, default: false }
    },
  setup(__props, { expose: __expose }) {
  __expose();

    const Props = __props;
    const menuToggle = ref();
    const toggleMenu = (event) => {
        menuToggle.value.toggle(event);
    };

const __returned__ = { Props, menuToggle, toggleMenu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})